jQuery(document).ready(function() {
  /* Header */
  function header_border() {
    var body_width = jQuery('body').width();
    var wrapper_width = jQuery('.page-width').width();
    var temp_width = body_width - wrapper_width; 
    var temp_width_2 = temp_width / 2;
	var temp_width_3 = temp_width_2 - temp_width_2 - temp_width_2;
    jQuery(".header__inline-menu .menu-border").css('width', body_width);
    jQuery(".header__inline-menu .menu-border").css('left', temp_width_3);
  }
  header_border();
  jQuery(window).on('load resize orientationchange', header_border);

  /* Slick Slider */
  jQuery('.announcement-slider').slick({
    arrows: false,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: false,
        }
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: false,
        }
      }
    ]
  });
  
  jQuery('.js-banner-slider').slick({
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    prevArrow:'<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.57001 5.93L3.50001 12L9.57001 18.07" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.5 12H3.67" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4301 5.93L20.5001 12L14.4301 18.07" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 12H20.33" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,          
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          adaptiveHeight: true,
        }
      }
    ]
  });
  
  /* Featured Collection Slider */
  var init = {      
      cssEase: "linear",
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 4000,
      prevArrow:'<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.57001 5.93L3.50001 12L9.57001 18.07" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.5 12H3.67" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4301 5.93L20.5001 12L14.4301 18.07" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 12H20.33" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
      {
        breakpoint: 600, 
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };
  
  $(function () {
    var win = $(window);
    var slider = $(".js-collection-slider, .uspbar-slider");
    win.on("load resize", function () {
      if (win.width() < 1024) {      
        slider.not(".slick-initialized").slick(init);
      } else if (slider.hasClass("slick-initialized")) {
        slider.slick("unslick");        
      }
    });
  });

  jQuery('.js-logo-slider').slick({
    arrows: false,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
    responsive: [
      {
        breakpoint: 1365,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        }
      }
    ]
  });
  
  /* About */
  jQuery('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
    prevArrow:'<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.57001 5.93L3.50001 12L9.57001 18.07" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.5 12H3.67" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4301 5.93L20.5001 12L14.4301 18.07" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 12H20.33" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',    
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
        }
      }
    ]
  });
  jQuery('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    prevArrow:'<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.57001 5.93L3.50001 12L9.57001 18.07" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.5 12H3.67" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4301 5.93L20.5001 12L14.4301 18.07" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 12H20.33" stroke="#6C7878" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  /* Footer Toggle */
  jQuery(".footer-block__heading").click(function(){
    jQuery(this).toggleClass('active');
    if(jQuery(this).hasClass('active')){
      jQuery('.footer-toggle').slideUp();
      jQuery('.footer-block__heading').not(this).removeClass('active');
      jQuery('.footer-block').removeClass('activeToggle');
      jQuery(this).addClass('active');
      jQuery(this).next('.footer-toggle').slideDown();
      jQuery(this).parent().addClass("activeToggle");
    } else {
      jQuery(this).removeClass('active');
      jQuery(this).next('.footer-toggle').slideUp();
      jQuery(this).parent().removeClass("activeToggle"); 
    }
  });
  
  /* Navigaton */
  function addQueryStringToLink(linkElement) {
    var href = jQuery(linkElement).attr("href");
    var queryString = href.indexOf("?") === -1 ? "?" : "&";
    href += queryString + "sort=created-descending";
    jQuery(linkElement).attr("href", href);
  }

  const checkDiv = setInterval(() => {
    if(jQuery('.tmenu_nav li.tmenu_item_level_0:first-child .tmenu_submenu .tmenu_item_link').length > 0) {
      jQuery(".tmenu_nav li.tmenu_item_level_0:first-child .tmenu_submenu .tmenu_item_link").each(function() {
        addQueryStringToLink(this);
      });
      clearInterval(checkDiv);
    }
    if(jQuery('.tmenu_app_mobile li.tmenu_item_level_0:first-child .tmenu_submenu .tmenu_item_link').length > 0) {
      jQuery(".tmenu_app_mobile li.tmenu_item_level_0:first-child .tmenu_submenu .tmenu_item_link").each(function() {
        addQueryStringToLink(this);
      });
      clearInterval(checkDiv);
    }
  }, 100);

   jQuery('.dock__menu').click(function() {
      jQuery('.header__icon--menu').trigger('click');
  });

 const deliveryCountdown = (() => {
    function formatDate(date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        return `${day}/${month}`;
    }

    function findNextDelivery(currentDateTime, deliverySchedule) {
        const currentDayOfWeek = currentDateTime.getDay();
        const currentTime = currentDateTime.toTimeString().slice(0, 5);
        for (let i = 0; i < 7; i++) {
            const nextDayOfWeek = (currentDayOfWeek + i) % 7;
            var nextDeliveryDayOfWeek = nextDayOfWeek + 1;
            var nextDelivery = deliverySchedule.find(schedule => schedule.dayOfWeek === nextDeliveryDayOfWeek);
            if (nextDelivery) {
                const nextDeliveryDateTime = new Date(currentDateTime);
                nextDeliveryDateTime.setDate(currentDateTime.getDate() + i);
                const [nextDeliveryHours, nextDeliveryMinutes] = nextDelivery.time.split(':');
                nextDeliveryDateTime.setHours(nextDeliveryHours, nextDeliveryMinutes, 0, 0);

                if (i === 0 && currentTime < nextDelivery.time) {
                    // Current day but before the delivery time
                    return { nextDeliveryDateTime, skipped: false };
                } else if (i > 0 || (i === 0 && currentTime >= nextDelivery.time)) {
                    // Future day or current day but after the delivery time
                    const skipped = i > 0 && !deliverySchedule.some(schedule => schedule.dayOfWeek === (nextDeliveryDayOfWeek) % 7);
                    return { nextDeliveryDateTime, skipped };
                }
            }else{
                nextDeliveryDayOfWeek = nextDeliveryDayOfWeek + 1;
                var nextDelivery = deliverySchedule.find(schedule => schedule.dayOfWeek === nextDeliveryDayOfWeek);  
                if (typeof nextDelivery === "undefined" && nextDeliveryDayOfWeek == 7) {
                  nextDeliveryDayOfWeek = 1;
                  nextDelivery = deliverySchedule.find(schedule => schedule.dayOfWeek === nextDeliveryDayOfWeek); 
                  var nextDeliveryDateTime = new Date(currentDateTime);
                  nextDeliveryDateTime.setDate(currentDateTime.getDate() + 2);
                }else{
                  var nextDeliveryDateTime = new Date(currentDateTime);
                  nextDeliveryDateTime.setDate(currentDateTime.getDate() + 1);
                }
                
                const [nextDeliveryHours, nextDeliveryMinutes] = nextDelivery.time.split(':');
                nextDeliveryDateTime.setHours(nextDeliveryHours, nextDeliveryMinutes, 0, 0);
                var skipped = true;
                return { nextDeliveryDateTime, skipped };
            }
        }

        return null;
    }
    function isTimeBetweenMidnightAndAM(hour, minute = 0) {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
    
        console.log('currentHour',currentHour,hour);
        if (currentHour < hour || (currentHour === hour && currentMinute < minute)) {
            return true;
        } else {
            return false;
        }
    }

    function updateCountdown(element, currentTime) {
        const deliverySchedule = window.deliverySchedule;
        const currentDateTime = new Date(currentTime);
        const currentDayOfWeek = currentDateTime.getDay();
      
        let message = '';
        const result = findNextDelivery(currentDateTime, deliverySchedule);

        if (result) {
            let { nextDeliveryDateTime, skipped } = result;

            console.log('nextDeliveryDateTime',nextDeliveryDateTime);
            let timeDifference = nextDeliveryDateTime - currentDateTime;

            const currentHours = currentDateTime.getHours();
            const currentMinutes = currentDateTime.getMinutes();
            const todayDelivery = deliverySchedule.find(schedule => schedule.dayOfWeek === currentDayOfWeek);
            if (todayDelivery) {
                const [deliveryHours, deliveryMinutes] = todayDelivery.time.split(':').map(Number);
                if (isTimeBetweenMidnightAndAM(deliveryHours)) {
                    document.querySelector('.missed_delivery__text').style.display = 'none';
                    document.querySelector('.missed-delivery-countdown__text').style.display = 'none';
                } else {
                    document.querySelector('.missed_delivery__text').style.display = 'block';
                    document.querySelector('.delivery-countdown__text').style.display = 'none';
                }
            }            

            if (timeDifference <= 0) {
                console.log('Today');
                // If the delivery time for today has passed, move to the next available day
                nextDeliveryDateTime.setDate(nextDeliveryDateTime.getDate() + 1);
                timeDifference = nextDeliveryDateTime - currentDateTime;
                nextDeliveryDateTime.setDate(nextDeliveryDateTime.getDate() + 1);
            }else{
                console.log('Tom');
                nextDeliveryDateTime.setDate(nextDeliveryDateTime.getDate() + 1);
            }

            if (timeDifference > 0) {
                const hours = Math.floor(timeDifference / 3600000);
                const minutes = Math.floor((timeDifference % 3600000) / 60000);
                const seconds = Math.floor((timeDifference % 60000) / 1000);

                if (!isNaN(hours) && !isNaN(minutes) && !isNaN(seconds)) {
                    const nextDeliveryFormattedDate = formatDate(nextDeliveryDateTime);

                    message = `<span class="delivery-date">(${nextDeliveryFormattedDate})</span><br><span class="time-remaining">Time remaining: <span class="time-remaining__value">${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}</span></span>`;

                    if (skipped) {
                        document.querySelector('.missed_delivery__text').style.display = 'block';
                    }
                }
            }
        } else {
            message = "<span class='delivery-unavailable'>No delivery available this week.</span>";
        }

        element.innerHTML = message || '';
    }

    return {
        initSectionDeliveryCountDown: function() {
            const timerElements = document.querySelectorAll(".delivery-countdown__timer");
            if (timerElements.length > 0) {
                timerElements.forEach(function(timerElement) {
                    setInterval(() => {
                        updateCountdown(timerElement, (new Date()).getTime());
                    }, 1000); // Update every second
                });
            }
        }
    };
})();

deliveryCountdown.initSectionDeliveryCountDown();
  
});